/**
 * @file SelectContextPage.tsx
 * @description Выбор контекста после логина (phase08.5 shadcn; phase19.29 —
 * тема и логотип Commora через CommoraAuthShell, «кабинет» вместо «контекста»).
 */

import { Loader2 } from "lucide-react";
import { Navigate, useNavigate } from "react-router";

import { CommoraAuthShell } from "../components/brand/CommoraAuthShell";
import { EditorialCard } from "../components/ui/EditorialCard";
import { Button } from "../components/ui/button";
import { formatContextLabel, landingPathFor } from "../auth/format";
import { useAuth } from "../auth/hooks";

export function SelectContextPage() {
  const { me, switchContext, status } = useAuth();
  const navigate = useNavigate();

  if (status === "loading") {
    return (
      <div className="flex min-h-screen items-center justify-center bg-background">
        <Loader2 className="size-8 animate-spin text-primary" />
      </div>
    );
  }

  if (!me) return <Navigate to="/login" replace />;
  if (me.activeContext)
    return <Navigate to={landingPathFor(me.activeContext)} replace />;
  if (me.contexts.length === 0) return <Navigate to="/no-context" replace />;

  async function onPick(contextId: string) {
    const updated = await switchContext(contextId);
    if (updated.activeContext) {
      navigate(landingPathFor(updated.activeContext), { replace: true });
    }
  }

  return (
    <CommoraAuthShell tabTitle="Выбор кабинета" wide>
      <div className="w-full">
        <div className="flex flex-col gap-6">
          <div className="flex flex-col gap-1">
            <h1 className="type-page-title text-on-surface">Выберите кабинет</h1>
            <p className="text-sm text-on-surface-variant">
              У вашей учётной записи несколько ролей. Выберите, в каком кабинете начать работу.
            </p>
          </div>

          <div className="flex flex-col gap-3">
            {me.contexts.map((ctx) => (
              <EditorialCard floating key={ctx.id}>
                <EditorialCard.Body>
                  <div className="flex items-center justify-between gap-4">
                    <div className="min-w-0">
                      <h2 className="type-card-title text-on-surface truncate">
                        {formatContextLabel(ctx)}
                      </h2>
                      <p className="text-xs text-on-surface-variant truncate">
                        {ctx.role.displayName}
                      </p>
                    </div>
                    <Button onClick={() => void onPick(ctx.id)}>Войти</Button>
                  </div>
                </EditorialCard.Body>
              </EditorialCard>
            ))}
          </div>
        </div>
      </div>
    </CommoraAuthShell>
  );
}
